import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileCallBar } from './components/MobileCallBar';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Gallery } from './pages/Gallery';
import { Reviews } from './pages/Reviews';
import { Faq } from './pages/Faq';
import { Contact } from './pages/Contact';
import { Legal } from './pages/Legal';
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3ikha0f5th31m">
      <BrowserRouter data-id="element-1" data-mp="3iiwasc8k4vxf">
        <ScrollManager data-id="element-2" data-mp="3ijpc2xoqyt86" />
        <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="3ii4ppvcl6gle">
          <Header data-id="element-4" data-mp="3mjq1fdddwou0" />
          <main className="flex-1 pb-20 sm:pb-0" data-id="element-5" data-mp="3mj6ipufwtwex">
            <Routes data-id="element-6" data-mp="3rdaq2et386gj">
              <Route path="/" element={<Home data-id="element-8" data-mp="3reltgdimfc74" />} data-id="element-7" data-mp="3rcswxr1q28cu" />
              <Route path="/about" element={<About data-id="element-10" data-mp="4wyzymxdckh" />} data-id="element-9" data-mp="5opiv1o0k3w" />
              <Route path="/services" element={<Services data-id="element-12" data-mp="2zl3dbpgpde7f" />} data-id="element-11" data-mp="56l3b4umzkw" />
              <Route path="/gallery" element={<Gallery data-id="element-14" data-mp="2zmwj72jhrued" />} data-id="element-13" data-mp="2zm4y4lnitf2c" />
              <Route path="/reviews" element={<Reviews data-id="element-16" data-mp="33lwzadal4ixo" />} data-id="element-15" data-mp="33mov9p83gioh" />
              <Route path="/faq" element={<Faq data-id="element-18" data-mp="33oi2b5mmd4x0" />} data-id="element-17" data-mp="33n6y54p9hv5d" />
              <Route path="/contact" element={<Contact data-id="element-20" data-mp="38l04bxqkep5n" />} data-id="element-19" data-mp="38m1jadapbvsn" />
              <Route path="/privacy" element={<Legal kind="privacy" data-id="element-22" data-mp="3dkl4gbhh13jy" />} data-id="element-21" data-mp="38nuorp9kw9z2" />
              <Route path="/terms" element={<Legal kind="terms" data-id="element-24" data-mp="3dirw8rr7mb9u" />} data-id="element-23" data-mp="3dlns8ajhypvn" />
              <Route path="*" element={<Home data-id="element-26" data-mp="nur762waucye" />} data-id="element-25" data-mp="nw2bq4xkjoqk" />
            </Routes>
          </main>
          <Footer data-id="element-27" data-mp="sudmchvou39u" />
          <MobileCallBar data-id="element-28" data-mp="stuczpk3sn7f" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}